/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ChronicCondition from './chronic-condition';
import ChronicConditionDetail from './chronic-condition-detail';
import ChronicConditionUpdate from './chronic-condition-update';
import ChronicConditionDeleteDialog from './chronic-condition-delete-dialog';

const ChronicConditionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ChronicCondition />} />
    <Route path="new" element={<ChronicConditionUpdate />} />
    <Route path=":id">
      <Route index element={<ChronicConditionDetail />} />
      <Route path="edit" element={<ChronicConditionUpdate />} />
      <Route path="delete" element={<ChronicConditionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ChronicConditionRoutes;
